module.exports = __webpack_public_path__ + "static/img/mazzo-di-carte-2.9c08343.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mazzo-di-carte-2.svg
// module id = 4Ge5
// module chunks = 1